export const SETUP_INIT_COMMAND = "npx agentreacher@latest init";

export const SETUP_LLM_INSTRUCTIONS = `Set up AgentReacher for me.

Fetch https://agentreacher.com/skill.md and follow the setup flow described there.`;

export const CLAUDE_MCP_ADD_COMMAND =
	"claude mcp add --transport http agentreacher https://agentreacher.com/mcp";

export const AGENTREACHER_MCP_URL = "https://agentreacher.com/mcp";
